var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteHoverIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 4.5,
    fill: "#F18221"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1402_9630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 11H26V10.5C26 9.83696 25.7366 9.20107 25.2678 8.73223C24.7989 8.26339 24.163 8 23.5 8H16.5C15.837 8 15.2011 8.26339 14.7322 8.73223C14.2634 9.20107 14 9.83696 14 10.5V11H9V14H11V29C11 29.7956 11.3161 30.5587 11.8787 31.1213C12.4413 31.6839 13.2044 32 14 32H26C26.7956 32 27.5587 31.6839 28.1213 31.1213C28.6839 30.5587 29 29.7956 29 29V14H31V11ZM26 29H14V14H26V29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 17H16V26H19V17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 17H21V26H24V17Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1402_9630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteHoverIcon);
export default __webpack_public_path__ + "static/media/delete-hover-icon.b1525b3efb4221214fa694656c077c4a.svg";
export { ForwardRef as ReactComponent };